import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-history.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-history.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { AppViewShortDatePipe } from "../../pipes/app-view-short-date/app-view-short-date.pipe";
import { ApplicationHistoryService } from "./application-history.service";
import { AppControllerService } from "../../../app-controller.service";
import { ApplicationHistoryConstants } from "./application-history.constants";
import { UcFirstPipe } from "ngx-pipes";
import { RouterParamsService } from "../../services/route-params.service";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { aflaModuleServiceProvider } from "../../services/afla-module-strategy/afla-module-strategy.service.provider";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let ApplicationHistoryComponent = class ApplicationHistoryComponent extends ApplicationBaseComponent {
    datePipe;
    applicationHistoryService;
    appController;
    changeDetectorRefs;
    ucFirst;
    currentStepService;
    aflaModuleStrategyService;
    routerParamsService;
    route;
    busyFetching = false;
    jobCurrentSteps = null;
    header = ApplicationHistoryConstants.HEADER;
    historyEntries = [];
    subscribeToCurrentStepsSubscription;
    getAuditActionObservableSubscription;
    constructor(datePipe, applicationHistoryService, appController, changeDetectorRefs, ucFirst, currentStepService, aflaModuleStrategyService, routerParamsService, route) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.datePipe = datePipe;
        this.applicationHistoryService = applicationHistoryService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.ucFirst = ucFirst;
        this.currentStepService = currentStepService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.routerParamsService = routerParamsService;
        this.route = route;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        if (this.jobCurrentSteps != null && this.jobCurrentSteps.length === this.currentStepService.currentSteps.length) {
            for (let i = 0, len = this.jobCurrentSteps.length; i < len; i++) {
                if (this.jobCurrentSteps[i].id === this.currentStepService.currentSteps[i].id) {
                    return;
                }
            }
        }
        this.jobCurrentSteps = this.currentStepService.currentSteps;
        this.fetchAuditActions();
    }
    handleRouteChange() {
        this.fetchAuditActions();
    }
    fetchAuditActions() {
        if (this.jobID !== undefined && this.jobID !== null && !this.busyFetching) {
            this.busyFetching = true;
            const params = {
                $expand: "user",
                $filter: `jobId eq ${this.jobID} and description ne 'Saved Step'`,
                $orderby: "date desc",
                $top: 10
            };
            this.getAuditActionObservableSubscription = this.applicationHistoryService.getAuditActionObservable(params)
                .subscribe((result) => {
                this.historyEntries = [];
                // tslint:disable-next-line:prefer-for-of
                for (let i = 0; i < result.value.length; i++) {
                    const audit = result.value[i];
                    const history = {
                        id: audit.id,
                        jobId: audit.jobId,
                        moduleId: audit.moduleId,
                        organisationId: audit.organisationId,
                        date: this.datePipe.transform(audit.date),
                        userId: audit.userId,
                        action: audit.action,
                        component: audit.component,
                        componentIdentifier: audit.componentIdentifier,
                        description: audit.description,
                        deleted: audit.deleted,
                        userName: "System"
                    };
                    if (audit.user !== undefined && audit.user !== null) {
                        // tslint:disable-next-line:max-line-length
                        history.userName = this.ucFirst.transform(audit.user.firstName.toLowerCase()) + " " + this.ucFirst.transform(audit.user.lastName.toLowerCase());
                    }
                    this.historyEntries.push(history);
                }
                this.historyEntries.sort((a, b) => 0 - (a.date.toLowerCase() < b.date.toLowerCase() ? -1 : 1));
                this.changeDetectorRefs.detectChanges();
                this.busyFetching = false;
            }, (error) => {
                this.appController.handleServerErrorMessage(ApplicationHistoryConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.busyFetching = false;
            });
        }
    }
    static ctorParameters = () => [
        { type: AppViewShortDatePipe },
        { type: ApplicationHistoryService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: UcFirstPipe },
        { type: CurrentStepService },
        { type: AflaModuleStrategyService },
        { type: RouterParamsService },
        { type: ActivatedRoute }
    ];
};
ApplicationHistoryComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-application-history",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ApplicationHistoryComponent);
export { ApplicationHistoryComponent };
